import { Link, useLocation } from "react-router-dom";

const SubTabItem = ({
  pathname,
  tab,
  color,
}: {
  pathname: string;
  tab: any;
  color: string | null;
}) => {
  // url이 /management/seminar_weekly일 때 /management/seminar도 하이라이트 되는 문제 해결
  const seminarException =
    pathname.includes("/management/seminar_weekly") && tab.url === "/management/seminar";

  // url이 /recruit이거나 /recruit/chicruiting일 때 치과위생사가 하이라이트 되도록 함
  const recruitException =
    (pathname === "/recruit" && tab.url === "/recruit/hygienist") ||
    (pathname.includes("/recruit/chicruiting") && tab.url === "/recruit/hygienist");

  const location = useLocation();
  const urlParam = new URLSearchParams(location.search);
  const board = parseInt(urlParam.get("cate") || "0");

  const LinkClassName = () => {
    const className = "text-[14px] py-[9px] flex items-center ";

    if (color) {
      if ((pathname.includes(tab.url) && !seminarException) || recruitException) {
        return (
          className +
          `text-${color} text-opacity-100 font-bold border-b-[3px] border-solid border-${color}`
        );
      } else {
        return className + `text-${color} text-opacity-50 hover:text-opacity-100`;
      }
    } else if (board === tab.cate_cd) {
      return className + "text-primary-800 border-b-[3px] border-solid border-primary-800";
    } else {
      if ((pathname.includes(tab.url) && !seminarException) || recruitException) {
        return (
          className + "text-primary-800 font-medium border-b-[3px] border-solid border-primary-800"
        );
      } else {
        return className + "text-gray-600 hover:text-primary-800";
      }
    }
  };

  return (
    <>
      <Link className={LinkClassName()} to={tab.url}>
        {tab.cate_name === "AI 임상검색" && (
          <span className="w-4 h-4 mr-1 bg-[url('/img/ai/icon-badge-gradient.svg')] bg-no-repeat bg-center bg-cover"></span>
        )}
        {tab.cate_name}
      </Link>
    </>
  );
};

export default SubTabItem;
